// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.5_@swc+helpers@0.5.11__webpack@5.101.3_@swc+core@1.4.17_@swc+helpers@0.5.11__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-layout-breadcrumb {
  flex: 1;
  margin-bottom: 8px;
}
.components-layout-breadcrumb .ant-breadcrumb > span:last-child a {
  color: black;
  font-weight: bolder;
}
@media print {
  .components-layout-breadcrumb {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/components/layout/BreadcrumbCreator/index.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,kBAAA;AACF;AAHA;EAKI,YAAA;EACA,mBAAA;AACJ;AAEE;EAAA;IACE,aAAA;EACF;AACF","sourcesContent":[".components-layout-breadcrumb {\n  flex: 1;\n  margin-bottom: 8px;\n\n  .ant-breadcrumb > span:last-child a {\n    color: black;\n    font-weight: bolder;\n  }\n\n  @media print {\n    display: none;\n  }\n}\n\n@badge-height: 16px;@badge-font-size: 9.6px;@fill-body: #FFFFFF;@menu-collapsed-width: 64px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
